import React from 'react';
import { Col, Container, Image, Row } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import WeddingBannerImg from '../../../Assets/images/magnolia-img/landing-page-img/wedding-banner-mobile.jpg';

const WeddingBanner = () => {
  return (
    <>
      <div className="dfl_wedding_banner_section">
        <Container className="dfl_custome_container_staticpage">
          <Row className="w-100 m-auto">
            {/* <Col sm={12} md={6} lg={6} className="p-0">
                            <div className='text-center'>
                                <Image src={WeddingBannerImg} className="img-fluid" alt="Wedding banner Image" />
                            </div>
                        </Col> */}
            <Col
              sm={12}
              md={{ span: 6, offset: 6 }}
              lg={{ span: 6, offset: 6 }}
              className="dfl_eng_box"
            >
              <div className="def_wedding_text_box banner_cotntent">
                <Image
                  src={WeddingBannerImg}
                  className="img-fluid dfl_wed_banner_d_none_desktop"
                  alt="Wedding banner Image"
                />
                <h1>WEDDING RINGS AND BANDS</h1>
                <p>
                  We offer a wide collection of wedding rings and bands. We
                  understand the importance of a wedding ring and band. It stays
                  with a person for eternity. Hence, each of our rings and bands
                  is handcrafted with exquisite stones. You can choose from
                  precious metals like platinum and gold.
                </p>
                <NavLink to="/jewelry/wedding-rings">Shop rings</NavLink>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default WeddingBanner;
